import { render } from "./CreatePlanDetailForm.vue?vue&type=template&id=55c4d126&scoped=true"
import script from "./CreatePlanDetailForm.vue?vue&type=script&lang=js"
export * from "./CreatePlanDetailForm.vue?vue&type=script&lang=js"

import "./CreatePlanDetailForm.vue?vue&type=style&index=0&id=55c4d126&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c4d126"]])

export default __exports__